import { FC } from 'react'
import { Box, Flex, Grid } from '@/components/atoms/Grid'
import { validFor } from '@/theme/validFor'
import styled from 'styled-components'
import { H2 } from '@/components/atoms/typography'
import BlogCard from './blogCard'
import Pager from '@/components/molecules/pager'
import { useRouter } from 'next/router'
import { getPageFromRouterOrDefault } from '@/utils/urlHelper'
import useTranslation from 'next-translate/useTranslation'
import { usePagination } from './usePagination'
import { Blog } from '@/network/graphql.g'

type BlogPostsProps = {
  blogPosts: Blog[]
  blog?: Blog
}

const BlogPosts: FC<BlogPostsProps> = ({ blogPosts, blog }) => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const postsPerPage = 6
  const numberOfPages = Math.ceil(blogPosts?.length / postsPerPage)

  const { page, handlePageChange } = usePagination(
    getPageFromRouterOrDefault(router)
  )

  const startIndex = (page - 1) * postsPerPage
  const endIndex = Math.min(startIndex + postsPerPage, blogPosts?.length)

  const displayedPosts = blogPosts
    ?.filter((post) => post?.id !== blog?.id)
    .slice(startIndex, endIndex)

  return (
    <StyledFlex alignItems="center" flexDirection="column" pt={3} pb={3}>
      <StyledH2>{t('Blog.blogPosts')}:</StyledH2>
      <BlogPostsContainer>
        {displayedPosts?.map((post) => (
          <BlogCard key={post.id} post={post} />
        ))}
      </BlogPostsContainer>
      <Box mt={3} mb={3}>
        <Pager
          onClick={handlePageChange}
          numberOfPages={numberOfPages}
          currentPageIndex={page}
        />
      </Box>
    </StyledFlex>
  )
}

export default BlogPosts

const StyledFlex = styled(Flex)`
  width: 100%;
  ${validFor.mobile` 
    padding-bottom: 28px;
	`};
`

const StyledH2 = styled(H2)`
  font-size: 22px;
  ${validFor.mobile`
  font-size: 20px;`}
`

const BlogPostsContainer = styled(Grid)`
  grid-template-columns: 1fr 1fr 1fr;
  grid-gap: 20px;
  padding-block: 20px;
  width: 100%;
  ${validFor.tablet` 
    grid-template-columns: 1fr 1fr; 
	`};
  ${validFor.mobile` 
    grid-template-columns: 1fr; 
	`};
`
